import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import VariableType from 'app/admin/modelAnn/dto/VariableType';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import ModelCalculate from 'app/admin/common/component/ModelCalculate';
import StorageDriverService from 'app/admin/driver/service/StorageDriverService';
import EditFormComponentMassSomethingField from '../../common/component/EditFormComponentMassSomethingField';
import OpcModelEditService from '../service/OpcModelEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	const storageDriverService = new StorageDriverService();
	return {
		key: 'opcModelEditForm',
		topic: 'model',
		service: OpcModelEditService,
		// noNavigationAfterSave: data.id === 'new',
		// noNavigationAfterSaveNewLink: result => `/model-opc/${result.id}`,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'inputAttributes' }, { key: 'outputAttributes' }];
		},
		backLink: () => '/model',
		defaultValue: () => OpcModelEditService.create(data.driverName),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'driver',
					component: EditFormSelectField,
					required: true,
					items: () => storageDriverService.getListSelectionByDriverType('opc')
				},
				{
					key: 'version',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'endpoint',
					component: EditFormTextField
				},
				{
					key: 'image',
					component: EditFormFileInputField,
					required: true
				},
				{
					key: 'inputAttributes',
					tab: 'inputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						name: null,
						type: null,
						uom: null,
						expression: null,
						orderIndex: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(VariableType).map(key => {
								return { label: VariableType[key], value: key };
							})
						},
						{
							key: 'expression',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							onlyNumber: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							required: true,
							dependsOn: 'type',
							type: 'MIN_MAX_EXPRESSION',
							visibleIf: type => type === 'ComponentMassFlow' || type === 'ComponentMassFrac'
						},
						{
							key: 'minValue',
							component: EditFormTextField,
							required: true,
							onlyNumber: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'maxValue',
							component: EditFormTextField,
							required: true,
							onlyNumber: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true,
							// dependsOn: 'type',
							// visibleIf: type => type === 'SpreadSheet' || type === 'Variable'
						}
					]
				},
				{
					key: 'outputAttributes',
					tab: 'outputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						name: null,
						type: null,
						spreadsheet: null,
						uom: null,
						expression: null,
						orderIndex: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(VariableType).map(key => {
								return { label: VariableType[key], value: key };
							})
						},
						{
							key: 'expression',
							component: EditFormTextField,
							required: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							onlyNumber: true,
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							required: true,
							dependsOn: 'type',
							type: 'NAME_VALUE_EXPRESSION',
							visibleIf: type => type === 'ComponentMassFlow' || type === 'ComponentMassFrac'
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true,
							// dependsOn: 'type',
							// visibleIf: type => type === 'SpreadSheet' || type === 'Variable'
						}
					]
				}
			];
			return fields;
		}
	};
};

function OpcModelEditForm() {
	const { id, tabKey, driverName } = useParams();
	const dispatch = useDispatch();
	const myConfig = config({ id, driverName });
	return (
		<EditFormPage
			config={myConfig}
			startTabValue={tabKey}
			beforeSaveContent={<ModelCalculate id={id} type="model" />}
		/>
	);
}

export default withRouter(OpcModelEditForm);
